import type { DataQualityRow, LoyaltyRow, MasterProfile, OrderRow } from "../../../types";
import { currencyFormatter } from "../../../lib/presentation";

export function getProfileNextAction(
    profile: MasterProfile,
    relatedIssueCount: number
): string {
    if (profile.status === "Рисков клиент") {
        return "Пусни преглед за сливане между каналните профили преди следваща кампания или ръчна редакция.";
    }

    if (profile.consent === "Липсва") {
        return "Събери валидно съгласие при следваща покупка или през дигитална активация на картата.";
    }

    if (relatedIssueCount > 0) {
        return "Затвори висящите задачи по качеството на данните, преди профилът да се използва за сегментиране.";
    }

    if (profile.loyaltyCard === "Няма") {
        return "Предложи регистрация към Червена карта, за да свържем офлайн и онлайн поведението.";
    }

    return "Профилът е готов за сегментация, кампанийни аудитории и бъдеща атрибуция на поръчки.";
}

export function buildPath(path: string, params: Record<string, string | undefined>) {
    const searchParams = new URLSearchParams();

    for (const [key, value] of Object.entries(params)) {
        if (value) {
            searchParams.set(key, value);
        }
    }

    const query = searchParams.toString();
    return query ? `${path}?${query}` : path;
}

export function getHighestIssueSeverity(issues: DataQualityRow[]) {
    if (issues.some((issue) => issue.severity === "Високо")) {
        return "Високо";
    }

    if (issues.some((issue) => issue.severity === "Средно")) {
        return "Средно";
    }

    return "Ниско";
}

export function getHealthScore(
    profile: MasterProfile,
    loyaltyCard: LoyaltyRow | null,
    orders: OrderRow[],
    issues: DataQualityRow[]
) {
    let score = 100;

    if (profile.status === "Частичен") score -= 15;
    if (profile.status === "Рисков клиент") score -= 30;
    if (profile.consent === "Липсва") score -= 20;
    if (!loyaltyCard) score -= 15;
    if (loyaltyCard?.status === "Нужна валидация") score -= 10;
    if (orders.length === 0) score -= 15;
    score -= issues.filter((issue) => issue.severity === "Високо").length * 12;
    score -= issues.filter((issue) => issue.severity === "Средно").length * 6;

    return Math.max(12, Math.min(100, score));
}

export function getHealthTone(score: number) {
    if (score < 55) return "critical";
    if (score < 80) return "neutral";
    return "positive";
}

export function getContactReadiness(profile: MasterProfile) {
    if (profile.consent === "Липсва") return "Не е готов";
    if (profile.consent.includes("SMS") || profile.consent.includes("Viber")) {
        return "Готов за директен контакт";
    }
    return "Частично готов";
}

export function getOrderFrequency(orders: OrderRow[]) {
    if (orders.length >= 12) return "Много активен клиент";
    if (orders.length >= 6) return "Редовен клиент";
    if (orders.length >= 3) return "Повтарящ се клиент";
    if (orders.length >= 2) return "Епизодичен клиент";
    if (orders.length === 1) return "Единична поръчка";
    return "Още няма история";
}

export function formatIssueCount(count: number) {
    return count === 1 ? "1 сигнал" : `${count} сигнала`;
}

export function getLastOrderValue(orders: OrderRow[]) {
    return orders[0] ? currencyFormatter.format(orders[0].value) : "Няма";
}
